import React, {Suspense} from 'react';
import DashboardLeft from '../../shared/DashboardLeft';
import Header from '../../shared/Header';
import Footer from '../../shared/Footer';
import FormRule from '../form/FormRule';
import Translator from '../../translations/Translator';
import Line from '../../shared/Line';

function PageRulesForm() {
    document.title = 'Rule - zizier';
    return (
        <Suspense
            fallback={
                <p>
                    <Translator value="i18n.loading" />
                </p>
            }
        >
            <div className="row">
                <Header />
                <DashboardLeft />
                <div className="col-md-9">
                    <h5>
                        <Translator value="i18n.rule.form" />
                    </h5>
                    <Line />
                    <FormRule />
                </div>
                <Footer />
            </div>
        </Suspense>
    );
}

export default PageRulesForm;
